import React, { Component } from 'react';
import { loadStripe } from '@stripe/stripe-js';

export class ContactWithPayment extends Component {
	render() {
		// Make sure to call `loadStripe` outside of a component’s render to avoid
		// recreating the `Stripe` object on every render.
		const stripePromise = loadStripe(
			'pk_test_51HREbgJmWLoAA8ClH0zlIITvCtXhTLW8IqyP3DK2fs7OirJZVzjYL3k72MKAOBy38V1X5aZkZtlTqBKnyOVaBWJc00r5paK8IG'
		);

		const handleClick = async (event) => {
			// Get Stripe.js instance
			const stripe = await stripePromise;

			// https://137.135.69.197:4000/create-checkout-session
			// https://nocsys.eastus.cloudapp.azure.com/
			// http://pagos.nocsys.co.uk/
			// https://nocsys.eastus.cloudapp.azure.com:4000/create-checkout-session
			// Call your backend to create the Checkout Session
			const response = await fetch(
				'https://nocsys.eastus.cloudapp.azure.com:4000/create-checkout-session',
				{
					method: 'POST',
					credentials: 'same-origin',
				}
			);

			const session = await response.json();
			// When the customer clicks on the button, redirect them to Checkout.
			const result = await stripe.redirectToCheckout({
				sessionId: session.id,
			});

			if (result.error) {
				// If `redirectToCheckout` fails due to a browser or network
				// error, display the localized error message to your customer
				// using `result.error.message`.
			}
		};

		return (
			<div>
				<div id='contactwithpayment'>
					<div className='container'>
						<div className='col-md-8'>
							<div className='row'>
								<div className='section-title'>
									<h2>¿ Te gusta nuestra propuesta ?</h2>
									<p>
										Creemos que nuestra propuesta es de grán valor para tí.
										Dejanos tus datos y con gusto uno de nuestros asesores,
										platicara contigo y escuchará tus necesidades.
									</p>
								</div>
								<form name='sentMessage' id='contactForm' noValidate>
									<div className='row'>
										<div className='col-md-6'>
											<div className='form-group'>
												<input
													type='text'
													id='name'
													className='form-control'
													placeholder='Name'
													required='required'
												/>
												<p className='help-block text-danger'></p>
											</div>
										</div>
										<div className='col-md-6'>
											<div className='form-group'>
												<input
													type='email'
													id='email'
													className='form-control'
													placeholder='Email'
													required='required'
												/>
												<p className='help-block text-danger'></p>
											</div>
										</div>
									</div>
									<div className='form-group'>
										<textarea
											name='message'
											id='message'
											className='form-control'
											rows='4'
											placeholder='Message'
											required
										></textarea>
										<p className='help-block text-danger'></p>
									</div>
									<div id='success'></div>
									<button type='submit' className='btn btn-custom btn-lg'>
										Llamarme por favor
									</button>
								</form>
								<div className='section-title'>
									<h2>
										Tambien puedes en éste instante adquirir el curso , y si lo
										haces , tenemos una grandiosa oferta.
									</h2>
									<h2>
										{' '}
										Cupon de 50% de descuento en el segúndo Curso , a tu
										elección{' '}
									</h2>
								</div>
								<div>
									<p> Numero de Tarjeta para pruebas : 4242 4242 4242 4242</p>
									<button
										role='link'
										onClick={handleClick}
										className='btn btn-danger btn-lg'
									>
										Contratar Ahora el Curso
									</button>
								</div>
							</div>
						</div>
						<div className='col-md-3 col-md-offset-1 contact-info'>
							<div className='contact-item'>
								<h3>Informacion de Contacto</h3>
								<p>
									<span>
										<i className='fa fa-map-marker'></i> Address
									</span>
									{this.props.data ? this.props.data.address : 'loading'}
								</p>
							</div>
							<div className='contact-item'>
								<p>
									<span>
										<i className='fa fa-phone'></i> Phone
									</span>{' '}
									{this.props.data ? this.props.data.phone : 'loading'}
								</p>
							</div>
							<div className='contact-item'>
								<p>
									<span>
										<i className='fa fa-envelope-o'></i> Email
									</span>{' '}
									{this.props.data ? this.props.data.email : 'loading'}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div id='footer'>
					<div className='container text-center'>
						<p>---</p>
					</div>
				</div>
			</div>
		);
	}
}

export default ContactWithPayment;
